const provice_citys = [
    {
        "provice": "安徽",
        "cityList": [{"longitude": "116.794664", "latitude": "33.971707", "cityName": "淮北"}, {
            "longitude": "118.506502",
            "latitude": "31.669611",
            "cityName": "马鞍山"
        }, {"longitude": "116.999933", "latitude": "32.625478", "cityName": "淮南"}, {
            "longitude": "117.363228",
            "latitude": "32.939667",
            "cityName": "蚌埠"
        }, {"longitude": "118.376451", "latitude": "31.326319", "cityName": "芜湖"}, {
            "longitude": "117.227308",
            "latitude": "31.82057",
            "cityName": "合肥"
        }, {"longitude": "117.816576", "latitude": "30.929935", "cityName": "铜陵"}, {
            "longitude": "117.043551",
            "latitude": "30.50883",
            "cityName": "安庆"
        }, {"longitude": "118.316264", "latitude": "32.303627", "cityName": "滁州"}, {
            "longitude": "115.819729",
            "latitude": "32.896969",
            "cityName": "阜阳"
        }, {"longitude": "118.160515", "latitude": "30.140751", "cityName": "黄山"}, {
            "longitude": "116.984084",
            "latitude": "33.633891",
            "cityName": "宿州"
        }, {"longitude": "118.757995", "latitude": "30.945667", "cityName": "宣城"}, {
            "longitude": "116.507676",
            "latitude": "31.752889",
            "cityName": "六安"
        }, {"longitude": "115.782939", "latitude": "33.869338", "cityName": "亳州"}, {
            "longitude": "117.489157",
            "latitude": "30.656037",
            "cityName": "池州"
        }]
    },
    {
        "provice": "福建",
        "cityList": [{"longitude": "118.110221", "latitude": "24.490474", "cityName": "厦门"}, {
            "longitude": "117.635001",
            "latitude": "26.265444",
            "cityName": "三明"
        }, {"longitude": "119.296389", "latitude": "26.074268", "cityName": "福州"}, {
            "longitude": "118.675847",
            "latitude": "24.87435",
            "cityName": "泉州"
        }, {"longitude": "117.661801", "latitude": "24.510897", "cityName": "漳州"}, {
            "longitude": "118.081325",
            "latitude": "27.382829",
            "cityName": "南平"
        }, {"longitude": "119.527082", "latitude": "26.659241", "cityName": "宁德"}, {
            "longitude": "117.01728",
            "latitude": "25.075097",
            "cityName": "龙岩"
        }, {"longitude": "119.007558", "latitude": "25.431011", "cityName": "莆田"}]
    },
    {
        "provice": "广东",
        "cityList": [{"longitude": "113.597313", "latitude": "24.811094", "cityName": "韶关"}, {
            "longitude": "113.553986",
            "latitude": "22.224979",
            "cityName": "珠海"
        }, {"longitude": "116.708463", "latitude": "23.37102", "cityName": "汕头"}, {
            "longitude": "113.122717",
            "latitude": "23.028762",
            "cityName": "佛山"
        }, {"longitude": "113.264385", "latitude": "23.129112", "cityName": "广州"}, {
            "longitude": "114.085947",
            "latitude": "22.547",
            "cityName": "深圳"
        }, {"longitude": "113.094942", "latitude": "22.590431", "cityName": "江门"}, {
            "longitude": "110.364977",
            "latitude": "21.274898",
            "cityName": "湛江"
        }, {"longitude": "110.919229", "latitude": "21.659751", "cityName": "茂名"}, {
            "longitude": "112.472529",
            "latitude": "23.051546",
            "cityName": "肇庆"
        }, {"longitude": "116.117582", "latitude": "24.299112", "cityName": "梅州"}, {
            "longitude": "114.412599",
            "latitude": "23.079404",
            "cityName": "惠州"
        }, {"longitude": "115.364238", "latitude": "22.774485", "cityName": "汕尾"}, {
            "longitude": "114.697802",
            "latitude": "23.746266",
            "cityName": "河源"
        }, {"longitude": "113.051227", "latitude": "23.685022", "cityName": "清远"}, {
            "longitude": "111.982697",
            "latitude": "21.857415",
            "cityName": "阳江"
        }, {"longitude": "113.746262", "latitude": "23.046237", "cityName": "东莞"}, {
            "longitude": "113.382391",
            "latitude": "22.521113",
            "cityName": "中山"
        }, {"longitude": "116.632301", "latitude": "23.661701", "cityName": "潮州"}, {
            "longitude": "116.355733",
            "latitude": "23.543778",
            "cityName": "揭阳"
        }, {"longitude": "112.044439", "latitude": "22.929801", "cityName": "云浮"}]
    },
    {
        "provice": "广西",
        "cityList": [{"longitude": "109.411703", "latitude": "24.314617", "cityName": "柳州"}, {
            "longitude": "110.299121",
            "latitude": "25.274215",
            "cityName": "桂林"
        }, {"longitude": "111.297604", "latitude": "23.474803", "cityName": "梧州"}, {
            "longitude": "108.345478",
            "latitude": "21.614631",
            "cityName": "防城港"
        }, {"longitude": "108.36637", "latitude": "22.817746", "cityName": "南宁"}, {
            "longitude": "109.119254",
            "latitude": "21.473343",
            "cityName": "北海"
        }, {"longitude": "109.602146", "latitude": "23.0936", "cityName": "贵港"}, {
            "longitude": "106.616285",
            "latitude": "23.897742",
            "cityName": "百色"
        }, {"longitude": "110.180962", "latitude": "22.653889", "cityName": "玉林"}, {
            "longitude": "108.624175",
            "latitude": "21.967127",
            "cityName": "钦州"
        }, {"longitude": "111.552057", "latitude": "24.414141", "cityName": "贺州"}, {
            "longitude": "108.062106",
            "latitude": "24.695899",
            "cityName": "河池"
        }, {"longitude": "107.353926", "latitude": "22.404108", "cityName": "崇左"}, {
            "longitude": "109.229772",
            "latitude": "23.733766",
            "cityName": "来宾"
        }]
    },
    {
        "provice": "贵州",
        "cityList": [{"longitude": "105.28501", "latitude": "27.301693", "cityName": "毕节"}, {
            "longitude": "105.932188",
            "latitude": "26.245544",
            "cityName": "安顺"
        }, {"longitude": "106.937265", "latitude": "27.706626", "cityName": "遵义"}, {
            "longitude": "109.191555",
            "latitude": "27.718346",
            "cityName": "铜仁"
        }, {"longitude": "104.846743", "latitude": "26.584643", "cityName": "六盘水"}, {
            "longitude": "106.630153",
            "latitude": "26.647661",
            "cityName": "贵阳"
        }, {"longitude": "104.897971", "latitude": "25.08812", "cityName": "黔西南布依族苗族自治州"}, {
            "longitude": "107.977488",
            "latitude": "26.583352",
            "cityName": "黔东南苗族侗族自治州"
        }, {"longitude": "107.517156", "latitude": "26.258219", "cityName": "黔南布依族苗族自治州"}]
    },
    {
        "provice": "甘肃",
        "cityList": [{"longitude": "102.634697", "latitude": "37.929996", "cityName": "武威"}, {
            "longitude": "105.724998",
            "latitude": "34.578529",
            "cityName": "天水"
        }, {"longitude": "98.224194", "latitude": "39.803698", "cityName": "嘉峪关"}, {
            "longitude": "104.173606",
            "latitude": "36.54568",
            "cityName": "白银"
        }, {"longitude": "103.834249", "latitude": "36.06081", "cityName": "兰州"}, {
            "longitude": "102.187888",
            "latitude": "38.514238",
            "cityName": "金昌"
        }, {"longitude": "100.455472", "latitude": "38.932897", "cityName": "张掖"}, {
            "longitude": "104.929379",
            "latitude": "33.388598",
            "cityName": "陇南"
        }, {"longitude": "98.494352", "latitude": "39.732819", "cityName": "酒泉"}, {
            "longitude": "107.638372",
            "latitude": "35.734218",
            "cityName": "庆阳"
        }, {"longitude": "106.684691", "latitude": "35.54279", "cityName": "平凉"}, {
            "longitude": "104.626294",
            "latitude": "35.579578",
            "cityName": "定西"
        }, {"longitude": "103.212006", "latitude": "35.599446", "cityName": "临夏回族自治州"}, {
            "longitude": "102.911008",
            "latitude": "34.986354",
            "cityName": "甘南藏族自治州"
        }]
    },
    {
        "provice": "河北",
        "cityList": [{"longitude": "114.508851", "latitude": "37.0682", "cityName": "邢台"}, {
            "longitude": "115.464804",
            "latitude": "38.874062",
            "cityName": "保定"
        }, {"longitude": "119.586579", "latitude": "39.942531", "cityName": "秦皇岛"}, {
            "longitude": "114.490686",
            "latitude": "36.612273",
            "cityName": "邯郸"
        }, {"longitude": "118.175393", "latitude": "39.635113", "cityName": "唐山"}, {
            "longitude": "114.514793",
            "latitude": "38.042225",
            "cityName": "石家庄"
        }, {"longitude": "114.884091", "latitude": "40.811901", "cityName": "张家口"}, {
            "longitude": "117.939152",
            "latitude": "40.976204",
            "cityName": "承德"
        }, {"longitude": "116.857461", "latitude": "38.310582", "cityName": "沧州"}, {
            "longitude": "115.665993",
            "latitude": "37.735097",
            "cityName": "衡水"
        }, {"longitude": "116.704441", "latitude": "39.523927", "cityName": "廊坊"}]
    },
    {
        "provice": "龙江",
        "cityList": [{"longitude": "130.975966", "latitude": "45.300046", "cityName": "鸡西"}, {
            "longitude": "125.11272",
            "latitude": "46.590734",
            "cityName": "大庆"
        }, {"longitude": "130.277487", "latitude": "47.332085", "cityName": "鹤岗"}, {
            "longitude": "131.157304",
            "latitude": "46.643442",
            "cityName": "双鸭山"
        }, {"longitude": "123.95792", "latitude": "47.342081", "cityName": "齐齐哈尔"}, {
            "longitude": "126.535319",
            "latitude": "45.803131",
            "cityName": "哈尔滨"
        }, {"longitude": "128.899396", "latitude": "47.724775", "cityName": "伊春"}, {
            "longitude": "131.015584",
            "latitude": "45.771266",
            "cityName": "七台河"
        }, {"longitude": "129.618602", "latitude": "44.582962", "cityName": "牡丹江"}, {
            "longitude": "130.361634",
            "latitude": "46.809606",
            "cityName": "佳木斯"
        }, {"longitude": "127.499023", "latitude": "50.249585", "cityName": "黑河"}, {
            "longitude": "126.99293",
            "latitude": "46.637393",
            "cityName": "绥化"
        }, {"longitude": "124.117811", "latitude": "50.411047", "cityName": "大兴安岭"}]
    },
    {
        "provice": "河南",
        "cityList": [{"longitude": "112.434468", "latitude": "34.663041", "cityName": "洛阳"}, {
            "longitude": "114.341447",
            "latitude": "34.797049",
            "cityName": "开封"
        }, {"longitude": "114.352482", "latitude": "36.103442", "cityName": "安阳"}, {
            "longitude": "114.295444",
            "latitude": "35.748236",
            "cityName": "鹤壁"
        }, {"longitude": "113.783913", "latitude": "34.76239", "cityName": "郑州"}, {
            "longitude": "113.307718",
            "latitude": "33.735241",
            "cityName": "平顶山"
        }, {"longitude": "113.883991", "latitude": "35.302616", "cityName": "新乡"}, {
            "longitude": "114.026405",
            "latitude": "33.575855",
            "cityName": "漯河"
        }, {"longitude": "113.238266", "latitude": "35.23904", "cityName": "焦作"}, {
            "longitude": "113.826063",
            "latitude": "34.022956",
            "cityName": "许昌"
        }, {"longitude": "115.041299", "latitude": "35.768234", "cityName": "濮阳"}, {
            "longitude": "111.194099",
            "latitude": "34.777338",
            "cityName": "三门峡"
        }, {"longitude": "115.650497", "latitude": "34.437054", "cityName": "商丘"}, {
            "longitude": "114.075031",
            "latitude": "32.123274",
            "cityName": "信阳"
        }, {"longitude": "112.540918", "latitude": "32.999082", "cityName": "南阳"}, {
            "longitude": "114.649653",
            "latitude": "33.620357",
            "cityName": "周口"
        }, {"longitude": "114.024736", "latitude": "32.980169", "cityName": "驻马店"}, {
            "longitude": "112.601919",
            "latitude": "35.067243",
            "cityName": "济源"
        }]
    },
    {
        "provice": "湖北",
        "cityList": [{"longitude": "110.798657", "latitude": "32.629034", "cityName": "十堰"}, {
            "longitude": "115.077048",
            "latitude": "30.220074",
            "cityName": "黄石"
        }, {"longitude": "114.890593", "latitude": "30.396536", "cityName": "鄂州"}, {
            "longitude": "112.144146",
            "latitude": "32.042426",
            "cityName": "襄阳"
        }, {"longitude": "111.286451", "latitude": "30.69187", "cityName": "宜昌"}, {
            "longitude": "114.305215",
            "latitude": "30.592935",
            "cityName": "武汉"
        }, {"longitude": "112.204251", "latitude": "31.03542", "cityName": "荆门"}, {
            "longitude": "113.926656",
            "latitude": "30.926423",
            "cityName": "孝感"
        }, {"longitude": "112.23813", "latitude": "30.326857", "cityName": "荆州"}, {
            "longitude": "114.879365",
            "latitude": "30.447711",
            "cityName": "黄冈"
        }, {"longitude": "114.328963", "latitude": "29.832798", "cityName": "咸宁"}, {
            "longitude": "113.382477",
            "latitude": "31.690187",
            "cityName": "随州"
        }, {"longitude": "112.88868", "latitude": "30.433543", "cityName": "潜江"}, {
            "longitude": "113.453974",
            "latitude": "30.364953",
            "cityName": "仙桃"
        }, {"longitude": "110.680448", "latitude": "31.743483", "cityName": "神农架林区"}, {
            "longitude": "113.162071",
            "latitude": "30.647308",
            "cityName": "天门"
        }, {"longitude": "109.48699", "latitude": "30.283114", "cityName": "恩施土家族苗族自治州"}]
    },
    {
        "provice": "湖南",
        "cityList": [{"longitude": "111.46923", "latitude": "27.237842", "cityName": "邵阳"}, {
            "longitude": "113.132855",
            "latitude": "29.37029",
            "cityName": "岳阳"
        }, {"longitude": "113.151737", "latitude": "27.835806", "cityName": "株洲"}, {
            "longitude": "112.607693",
            "latitude": "26.900358",
            "cityName": "衡阳"
        }, {"longitude": "112.944038", "latitude": "27.829847", "cityName": "湘潭"}, {
            "longitude": "112.938888",
            "latitude": "28.228272",
            "cityName": "长沙"
        }, {"longitude": "111.691347", "latitude": "29.040225", "cityName": "常德"}, {
            "longitude": "110.479921",
            "latitude": "29.127401",
            "cityName": "张家界"
        }, {"longitude": "109.97824", "latitude": "27.550082", "cityName": "怀化"}, {
            "longitude": "111.608019",
            "latitude": "26.434516",
            "cityName": "永州"
        }, {"longitude": "113.014718", "latitude": "25.77051", "cityName": "郴州"}, {
            "longitude": "112.355042",
            "latitude": "28.570066",
            "cityName": "益阳"
        }, {"longitude": "112.008497", "latitude": "27.728136", "cityName": "娄底"}, {
            "longitude": "109.738783",
            "latitude": "28.311994",
            "cityName": "湘西土家族苗族自治州"
        }]
    },
    {
        "provice": "海南",
        "cityList": [{"longitude": "110.198286", "latitude": "20.044412", "cityName": "海口"}, {
            "longitude": "109.576782",
            "latitude": "19.517486",
            "cityName": "儋州"
        }, {"longitude": "109.508268", "latitude": "18.247872", "cityName": "三亚"}]
    },
    {
        "provice": "吉林",
        "cityList": [{"longitude": "125.936501", "latitude": "41.721177", "cityName": "通化"}, {
            "longitude": "126.427839",
            "latitude": "41.942505",
            "cityName": "白山"
        }, {"longitude": "124.370785", "latitude": "43.170344", "cityName": "四平"}, {
            "longitude": "125.145349",
            "latitude": "42.902692",
            "cityName": "辽源"
        }, {"longitude": "125.262598", "latitude": "43.815499", "cityName": "吉林"}, {
            "longitude": "125.323628",
            "latitude": "43.817001",
            "cityName": "长春"
        }, {"longitude": "122.841114", "latitude": "45.619026", "cityName": "白城"}, {
            "longitude": "124.823608",
            "latitude": "45.118243",
            "cityName": "松原"
        }, {"longitude": "129.513228", "latitude": "42.904823", "cityName": "延边朝鲜族自治州"}]
    },
    {
        "provice": "江苏",
        "cityList": [{"longitude": "119.946973", "latitude": "31.772752", "cityName": "常州"}, {
            "longitude": "117.184811",
            "latitude": "34.261792",
            "cityName": "徐州"
        }, {"longitude": "120.301663", "latitude": "31.574729", "cityName": "无锡"}, {
            "longitude": "118.796623",
            "latitude": "32.059352",
            "cityName": "南京"
        }, {"longitude": "120.619585", "latitude": "31.299379", "cityName": "苏州"}, {
            "longitude": "120.864608",
            "latitude": "32.016212",
            "cityName": "南通"
        }, {"longitude": "119.178821", "latitude": "34.600018", "cityName": "连云港"}, {
            "longitude": "119.021265",
            "latitude": "33.597506",
            "cityName": "淮安"
        }, {"longitude": "120.139998", "latitude": "33.377631", "cityName": "盐城"}, {
            "longitude": "119.924622",
            "latitude": "32.455809",
            "cityName": "泰州"
        }, {"longitude": "119.452753", "latitude": "32.204402", "cityName": "镇江"}, {
            "longitude": "119.421003",
            "latitude": "32.393159",
            "cityName": "扬州"
        }, {"longitude": "118.275162", "latitude": "33.963008", "cityName": "宿迁"}]
    },
    {
        "provice": "江西",
        "cityList": [{"longitude": "115.857963", "latitude": "28.683016", "cityName": "南昌"}, {
            "longitude": "117.214664",
            "latitude": "29.29256",
            "cityName": "景德镇"
        }, {"longitude": "113.852186", "latitude": "27.622946", "cityName": "萍乡"}, {
            "longitude": "115.992811",
            "latitude": "29.712034",
            "cityName": "九江"
        }, {"longitude": "117.033838", "latitude": "28.238638", "cityName": "鹰潭"}, {
            "longitude": "114.992737",
            "latitude": "27.706333",
            "cityName": "新余"
        }, {"longitude": "114.986373", "latitude": "27.111699", "cityName": "吉安"}, {
            "longitude": "114.391137",
            "latitude": "27.8043",
            "cityName": "宜春"
        }, {"longitude": "114.940278", "latitude": "25.85097", "cityName": "赣州"}, {
            "longitude": "116.358351",
            "latitude": "27.98385",
            "cityName": "抚州"
        }, {"longitude": "117.971185", "latitude": "28.44442", "cityName": "上饶"}]
    },
    {
        "provice": "辽宁",
        "cityList": [{"longitude": "122.995632", "latitude": "41.110626", "cityName": "鞍山"}, {
            "longitude": "123.770519",
            "latitude": "41.297909",
            "cityName": "本溪"
        }, {"longitude": "123.465009", "latitude": "41.677287", "cityName": "沈阳"}, {
            "longitude": "123.921109",
            "latitude": "41.875956",
            "cityName": "抚顺"
        }, {"longitude": "124.383044", "latitude": "40.124296", "cityName": "丹东"}, {
            "longitude": "121.618622",
            "latitude": "38.91459",
            "cityName": "大连"
        }, {"longitude": "121.648962", "latitude": "42.011796", "cityName": "阜新"}, {
            "longitude": "121.135742",
            "latitude": "41.119269",
            "cityName": "锦州"
        }, {"longitude": "122.235152", "latitude": "40.667432", "cityName": "营口"}, {
            "longitude": "123.18152",
            "latitude": "41.269402",
            "cityName": "辽阳"
        }, {"longitude": "122.069571", "latitude": "41.124484", "cityName": "盘锦"}, {
            "longitude": "123.844279",
            "latitude": "42.290585",
            "cityName": "铁岭"
        }, {"longitude": "120.451176", "latitude": "41.576758", "cityName": "朝阳"}, {
            "longitude": "120.856394",
            "latitude": "40.755572",
            "cityName": "葫芦岛"
        }]
    },
    {
        "provice": "蒙古",
        "cityList": [{"longitude": "109.840405", "latitude": "40.658168", "cityName": "包头"}, {
            "longitude": "111.748426",
            "latitude": "40.842723",
            "cityName": "呼和浩特"
        }, {"longitude": "106.825563", "latitude": "39.673734", "cityName": "乌海"}, {
            "longitude": "122.263119",
            "latitude": "43.617429",
            "cityName": "通辽"
        }, {"longitude": "118.886856", "latitude": "42.257817", "cityName": "赤峰"}, {
            "longitude": "119.758168",
            "latitude": "49.215333",
            "cityName": "呼伦贝尔"
        }, {"longitude": "122.070317", "latitude": "46.076268", "cityName": "兴安盟"}, {
            "longitude": "116.090996",
            "latitude": "43.944018",
            "cityName": "锡林郭勒盟"
        }, {"longitude": "107.416959", "latitude": "40.757402", "cityName": "巴彦淖尔"}, {
            "longitude": "113.114543",
            "latitude": "41.034126",
            "cityName": "乌兰察布"
        }, {"longitude": "105.706423", "latitude": "38.844814", "cityName": "阿拉善盟"}, {
            "longitude": "109.989261",
            "latitude": "39.817228",
            "cityName": "鄂尔多斯"
        }]
    },
    {
        "provice": "宁夏",
        "cityList": [{"longitude": "106.199409", "latitude": "37.986165", "cityName": "吴忠"}, {
            "longitude": "106.285241",
            "latitude": "36.004561",
            "cityName": "固原"
        }, {"longitude": "106.230909", "latitude": "38.487193", "cityName": "银川"}, {
            "longitude": "106.376173",
            "latitude": "39.01333",
            "cityName": "石嘴山"
        }, {"longitude": "105.189568", "latitude": "37.514951", "cityName": "中卫"}]
    },
    {
        "provice": "青海",
        "cityList": [{
            "longitude": "102.019988",
            "latitude": "35.517744",
            "cityName": "黄南藏族自治州"
        }, {"longitude": "101.778112", "latitude": "36.617042", "cityName": "西宁"}, {
            "longitude": "102.104287",
            "latitude": "36.50204",
            "cityName": "海东"
        }, {"longitude": "100.619542", "latitude": "36.280353", "cityName": "海南藏族自治州"}, {
            "longitude": "100.242143",
            "latitude": "34.4736",
            "cityName": "果洛藏族自治州"
        }, {"longitude": "100.90106", "latitude": "36.959435", "cityName": "海北藏族自治州"}, {
            "longitude": "97.008522",
            "latitude": "33.004049",
            "cityName": "玉树藏族自治州"
        }, {"longitude": "97.370785", "latitude": "37.374663", "cityName": "海西蒙古族藏族自治州"}]
    },
    {
        "provice": "山西",
        "cityList": [{"longitude": "112.851274", "latitude": "35.497553", "cityName": "晋城"}, {
            "longitude": "113.113556",
            "latitude": "36.191112",
            "cityName": "长治"
        }, {"longitude": "112.433387", "latitude": "39.331261", "cityName": "朔州"}, {
            "longitude": "112.549717",
            "latitude": "37.87046",
            "cityName": "太原"
        }, {"longitude": "113.583285", "latitude": "37.861188", "cityName": "阳泉"}, {
            "longitude": "113.295259",
            "latitude": "40.09031",
            "cityName": "大同"
        }, {"longitude": "112.736465", "latitude": "37.696495", "cityName": "晋中"}, {
            "longitude": "111.003957",
            "latitude": "35.022778",
            "cityName": "运城"
        }, {"longitude": "111.134335", "latitude": "37.524366", "cityName": "吕梁"}, {
            "longitude": "111.517973",
            "latitude": "36.08415",
            "cityName": "临汾"
        }, {"longitude": "112.733538", "latitude": "38.41769", "cityName": "忻州"}]
    },
    {
        "provice": "山东",
        "cityList": [{"longitude": "118.047649", "latitude": "36.814939", "cityName": "淄博"}, {
            "longitude": "118.66471",
            "latitude": "37.434564",
            "cityName": "东营"
        }, {"longitude": "121.391382", "latitude": "37.539297", "cityName": "烟台"}, {
            "longitude": "117.120098",
            "latitude": "36.6512",
            "cityName": "济南"
        }, {"longitude": "117.557964", "latitude": "34.856424", "cityName": "枣庄"}, {
            "longitude": "120.312724",
            "latitude": "36.064831",
            "cityName": "青岛"
        }, {"longitude": "119.107078", "latitude": "36.70925", "cityName": "潍坊"}, {
            "longitude": "117.129063",
            "latitude": "36.194968",
            "cityName": "泰安"
        }, {"longitude": "116.587245", "latitude": "35.415393", "cityName": "济宁"}, {
            "longitude": "122.116394",
            "latitude": "37.509691",
            "cityName": "威海"
        }, {"longitude": "119.461208", "latitude": "35.428588", "cityName": "日照"}, {
            "longitude": "117.677736",
            "latitude": "36.214397",
            "cityName": "莱芜"
        }, {"longitude": "118.016974", "latitude": "37.383542", "cityName": "滨州"}, {
            "longitude": "118.326443",
            "latitude": "35.065282",
            "cityName": "临沂"
        }, {"longitude": "115.980367", "latitude": "36.456013", "cityName": "聊城"}, {
            "longitude": "116.307428",
            "latitude": "37.453968",
            "cityName": "德州"
        }, {"longitude": "115.469381", "latitude": "35.246531", "cityName": "菏泽"}]
    },
    {
        "provice": "四川",
        "cityList": [{"longitude": "104.773447", "latitude": "29.352765", "cityName": "自贡"}, {
            "longitude": "104.398651",
            "latitude": "31.127991",
            "cityName": "德阳"
        }, {"longitude": "101.716008", "latitude": "26.580446", "cityName": "攀枝花"}, {
            "longitude": "105.443349",
            "latitude": "28.889138",
            "cityName": "泸州"
        }, {"longitude": "104.741722", "latitude": "31.46402", "cityName": "绵阳"}, {
            "longitude": "104.066143",
            "latitude": "30.573095",
            "cityName": "成都"
        }, {"longitude": "105.829757", "latitude": "32.433668", "cityName": "广元"}, {
            "longitude": "105.571331",
            "latitude": "30.513311",
            "cityName": "遂宁"
        }, {"longitude": "105.057987", "latitude": "29.580148", "cityName": "内江"}, {
            "longitude": "103.761263",
            "latitude": "29.582024",
            "cityName": "乐山"
        }, {"longitude": "106.082974", "latitude": "30.795282", "cityName": "南充"}, {
            "longitude": "103.831788",
            "latitude": "30.048318",
            "cityName": "眉山"
        }, {"longitude": "104.630825", "latitude": "28.760189", "cityName": "宜宾"}, {
            "longitude": "106.753669",
            "latitude": "31.858809",
            "cityName": "巴中"
        }, {"longitude": "106.633369", "latitude": "30.456398", "cityName": "广安"}, {
            "longitude": "103.001033",
            "latitude": "29.987722",
            "cityName": "雅安"
        }, {"longitude": "107.468023", "latitude": "31.209572", "cityName": "达州"}, {
            "longitude": "104.641917",
            "latitude": "30.122211",
            "cityName": "资阳"
        }, {"longitude": "102.221375", "latitude": "31.899792", "cityName": "阿坝藏族羌族自治州"}, {
            "longitude": "102.258746",
            "latitude": "27.886762",
            "cityName": "凉山彝族自治州"
        }, {"longitude": "101.963815", "latitude": "30.050663", "cityName": "甘孜藏族自治州"}]
    },
    {
        "provice": "陕西",
        "cityList": [{"longitude": "108.979608", "latitude": "34.916582", "cityName": "铜川"}, {
            "longitude": "109.502882",
            "latitude": "34.499381",
            "cityName": "渭南"
        }, {"longitude": "108.705117", "latitude": "34.333439", "cityName": "咸阳"}, {
            "longitude": "107.14487",
            "latitude": "34.369315",
            "cityName": "宝鸡"
        }, {"longitude": "108.939621", "latitude": "34.343147", "cityName": "西安"}, {
            "longitude": "109.49081",
            "latitude": "36.596537",
            "cityName": "延安"
        }, {"longitude": "109.029273", "latitude": "32.6903", "cityName": "安康"}, {
            "longitude": "109.918561",
            "latitude": "33.872706",
            "cityName": "商洛"
        }, {"longitude": "109.741193", "latitude": "38.290162", "cityName": "榆林"}, {
            "longitude": "107.028621",
            "latitude": "33.077668",
            "cityName": "汉中"
        }]
    },
    {
        "provice": "台湾",
        "cityList": [{"longitude": "109.372839", "latitude": "24.260678", "cityName": "基隆"}, {
            "longitude": "119.972182",
            "latitude": "31.830641",
            "cityName": "新北"
        }, {"longitude": "109.042815", "latitude": "34.383076", "cityName": "新竹"}, {
            "longitude": "120.548915",
            "latitude": "22.909117",
            "cityName": "高雄"
        }]
    },
    {
        "provice": "西藏",
        "cityList": [{"longitude": "94.36149", "latitude": "29.649128", "cityName": "林芝"}, {
            "longitude": "91.773134",
            "latitude": "29.237137",
            "cityName": "山南"
        }, {"longitude": "97.178452", "latitude": "31.136875", "cityName": "昌都"}, {
            "longitude": "88.885148",
            "latitude": "29.267519",
            "cityName": "日喀则"
        }, {"longitude": "92.051746", "latitude": "31.478148", "cityName": "那曲"}, {
            "longitude": "91.171961",
            "latitude": "29.653482",
            "cityName": "拉萨"
        }, {"longitude": "80.105498", "latitude": "32.503187", "cityName": "阿里"}]
    },
    {
        "provice": "新疆",
        "cityList": [{"longitude": "93.51316", "latitude": "42.833248", "cityName": "哈密"}, {
            "longitude": "87.616842",
            "latitude": "43.82539",
            "cityName": "乌鲁木齐"
        }, {"longitude": "89.189537", "latitude": "42.951227", "cityName": "吐鲁番"}, {
            "longitude": "82.074778",
            "latitude": "44.903258",
            "cityName": "博尔塔拉蒙古自治州"
        }, {"longitude": "87.308221", "latitude": "44.011184", "cityName": "昌吉回族自治州"}, {
            "longitude": "84.873946",
            "latitude": "45.595886",
            "cityName": "克拉玛依"
        }, {"longitude": "76.172825", "latitude": "39.713431", "cityName": "克孜勒苏柯尔克孜自治州"}, {
            "longitude": "86.150969",
            "latitude": "41.768552",
            "cityName": "巴音郭楞蒙古自治州"
        }, {"longitude": "80.265068", "latitude": "41.170712", "cityName": "阿克苏"}, {
            "longitude": "79.92533",
            "latitude": "37.110687",
            "cityName": "和田"
        }, {"longitude": "75.989138", "latitude": "39.467664", "cityName": "喀什"}, {
            "longitude": "81.317946",
            "latitude": "43.92186",
            "cityName": "伊犁哈萨克自治州"
        }, {"longitude": "82.985732", "latitude": "46.746301", "cityName": "塔城"}, {
            "longitude": "81.285884",
            "latitude": "40.541914",
            "cityName": "阿拉尔"
        }, {"longitude": "86.041075", "latitude": "44.305886", "cityName": "石河子"}, {
            "longitude": "79.074395",
            "latitude": "39.868951",
            "cityName": "图木舒克"
        }, {"longitude": "88.13963", "latitude": "47.848393", "cityName": "阿勒泰"}, {
            "longitude": "87.526685",
            "latitude": "44.160736",
            "cityName": "五家渠"
        }]
    },
    {
        "provice": "云南",
        "cityList": [{"longitude": "103.717216", "latitude": "27.336999", "cityName": "昭通"}, {
            "longitude": "102.543907",
            "latitude": "24.350461",
            "cityName": "玉溪"
        }, {"longitude": "103.797851", "latitude": "25.501557", "cityName": "曲靖"}, {
            "longitude": "99.167133",
            "latitude": "25.111802",
            "cityName": "保山"
        }, {"longitude": "100.233026", "latitude": "26.872108", "cityName": "丽江"}, {
            "longitude": "102.833722",
            "latitude": "24.881539",
            "cityName": "昆明"
        }, {"longitude": "100.08697", "latitude": "23.886567", "cityName": "临沧"}, {
            "longitude": "100.972344",
            "latitude": "22.777321",
            "cityName": "普洱"
        }, {"longitude": "104.24401", "latitude": "23.36951", "cityName": "文山壮族苗族自治州"}, {
            "longitude": "101.546046",
            "latitude": "25.041988",
            "cityName": "楚雄彝族自治州"
        }, {"longitude": "103.384182", "latitude": "23.366775", "cityName": "红河哈尼族彝族自治州"}, {
            "longitude": "100.797941",
            "latitude": "22.001724",
            "cityName": "西双版纳傣族自治州"
        }, {"longitude": "100.225668", "latitude": "25.589449", "cityName": "大理白族自治州"}, {
            "longitude": "98.578363",
            "latitude": "24.436694",
            "cityName": "德宏傣族景颇族自治州"
        }, {"longitude": "99.706463", "latitude": "27.826853", "cityName": "迪庆藏族自治州"}, {
            "longitude": "98.854304",
            "latitude": "25.850949",
            "cityName": "怒江傈僳族自治州"
        }]
    },
    {
        "provice": "浙江",
        "cityList": [{"longitude": "121.6216", "latitude": "29.859515", "cityName": "宁波"}, {
            "longitude": "120.750865",
            "latitude": "30.762653",
            "cityName": "嘉兴"
        }, {"longitude": "120.672111", "latitude": "28.000575", "cityName": "温州"}, {
            "longitude": "120.102398",
            "latitude": "30.867198",
            "cityName": "湖州"
        }, {"longitude": "120.582112", "latitude": "29.997117", "cityName": "绍兴"}, {
            "longitude": "120.209947",
            "latitude": "30.245853",
            "cityName": "杭州"
        }, {"longitude": "119.649506", "latitude": "29.089524", "cityName": "金华"}, {
            "longitude": "118.87263",
            "latitude": "28.941708",
            "cityName": "衢州"
        }, {"longitude": "122.106863", "latitude": "30.016028", "cityName": "舟山"}, {
            "longitude": "119.921786",
            "latitude": "28.451993",
            "cityName": "丽水"
        }, {"longitude": "121.428599", "latitude": "28.661378", "cityName": "台州"}]
    },

]
export default provice_citys;